import React from "react";
import { RadioGroup } from "../../../components";

import { AccountItem } from "./AccountItem";
import { COLOR } from "../../../components/theme";

export const Accounts = ({
  disabled = false,
  accounts = [],
  onChange = () => {},
  theme = {
    headingColor: COLOR.LATITUDE_BLUE_INDIGO,
    bodyTextColor: COLOR.LATITUDE_BLUE_INDIGO,
    backgroundColor: COLOR.SECONDARY_LIGHT_BLUE_25
  },
}) => {
  const handleAccountChange = (value) => {
    // TODO: implement disabled account check here
    const matchingAccount = accounts.find(
      ({ accountID }) => accountID === value
    );

    onChange(matchingAccount);
  };

  const radioOptions = accounts.map((acc) => ({
    ...acc,
    label: acc?.productName,
    value: acc?.accountID,
  }));

  const renderAccountItem = ({
    productCode,
    productName,
    availableBalance,
    points,
  }) => (
    <AccountItem
      productName={productName}
      productCode={productCode}
      availableBalance={availableBalance}
      points={points}
      theme={theme}
    />
  );

  return (
    <RadioGroup
      options={radioOptions}
      renderItem={renderAccountItem}
      onChange={handleAccountChange}
      isDisabled={disabled}
      selectFirstOption
      backgroundColor={theme.backgroundColor}
    />
  );
};
